import { forwardRef, type Ref, type SVGProps } from "react";
const IconBathroomOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 19v3.76A3.24 3.24 0 0 1 23.76 26H8.24A3.24 3.24 0 0 1 5 22.76V19zM5 17a2 2 0 0 0-2 2v3.76A5.26 5.26 0 0 0 8.24 28h15.52A5.26 5.26 0 0 0 29 22.76V19a2 2 0 0 0-2-2z" />
    <path d="M22 27v2a1 1 0 0 0 2 0v-2zM8 27v2a1 1 0 0 0 2 0v-2zM19.05 2a4.47 4.47 0 0 0-5 4.09 4 4 0 0 0-3 3.29.51.51 0 0 0 .5.59h6.92a.51.51 0 0 0 .5-.59 4 4 0 0 0-2.88-3.24A2.41 2.41 0 0 1 18.45 4 2.61 2.61 0 0 1 21 6.63V17h2V6.69A4.64 4.64 0 0 0 19.05 2" />
  </svg>
);
const ForwardRef = forwardRef(IconBathroomOutlineSVG);
ForwardRef.displayName = "IconBathroomOutline";
export { ForwardRef as IconBathroomOutline };
